const fontFamilies = {
  default: `'Euclid Circular A', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
  serif: `'MongoDB Value Serif', 'Times New Roman', serif`,
  code: `'Source Code Pro', Menlo, monospace`,
} as const;

export default fontFamilies;
